<template>
  <div class="text-body1">
    <div class="q-mb-sm">
      Here is the API key that you need to add to Litify:
    </div>
    <q-input label="API Key" :model-value="value" outlined readonly>
      <template v-slot:append>
        <q-btn
          icon="fa fa-copy"
          label="Copy"
          rounded
          flat
          @click="copy"
        />
      </template>
    </q-input>
    <div class="q-mt-md">
      <q-icon name="fa fa-exclamation-triangle" color="warning" />
      This is the only time we will show you this key.
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { copyToClipboard } from 'quasar';
import notify from '@/components/notify';

export default defineComponent({
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    copy() {
      copyToClipboard(this.value)
        .then(() => {
          notify('API Key copied to clipboard.');
        });
    },
  },
});
</script>
